export default __webpack_public_path__ + "static/media/speed2.641a3f6d.jpg";